import React from 'react';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu/Menu';
import MyHead from '../../components/MyHead';

const TermsAndConditionPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <MyHead />
      <div>
        <Menu />
        <div
          className="h-500 flex justify-center items-end py-3"
          style={{
            background: `linear-gradient(to bottom, rgba(0, 20, 26, 0.1), rgba(0, 20, 26, 0.25)), url("../../img/general-page-img.jpg")`
          }}
        >
          <h1 className="text-8xl sm:text-9xl text-white uppercase mb-6">
            {t('TERMS_CONDITION_TITLE')}
          </h1>
        </div>
        <div className="flex items-stretch flex-col py-20 max-w-4xl mx-auto px-4 sm:px-0">
          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE1')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION1') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE2')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION2') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE3')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION3') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE4')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION4') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE5')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION5') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE6')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION6') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE7')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION7') }}
            />
          </div>

          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE8')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION8') }}
            />
          </div>
          <div className="mb-10">
            <p className="font-bold mb-2">{t('TERMS_TITLE9')}</p>
            <p
              className="mb-5"
              dangerouslySetInnerHTML={{ __html: t('TERMS_DESCRIPTION9') }}
            />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsAndConditionPage;
